import { useConfetti } from '@/hooks/useConfetti';
import { useWindowSize } from '@/hooks/useWindowSize';
import { type FC } from 'react';
import ReactConfetti from 'react-confetti';

export const Confetti: FC = () => {
  const { show, running, onConfettiComplete } = useConfetti();
  const { width, height } = useWindowSize();

  if (!show) return null;

  return (
    <ReactConfetti
      width={width}
      height={height}
      recycle={running}
      numberOfPieces={running ? 500 : 0}
      tweenDuration={1000}
      style={{
        zIndex: 12000,
      }}
      onConfettiComplete={(confetti) => {
        confetti?.reset();
        onConfettiComplete();
      }}
    />
  );
};
